import { ADD_ORGANISATION_FAILED, ADD_ORGANISATION_LOADING, ADD_ORGANISATION_SUCCESS, APPROVE_REQUEST_LIST_FAILED, APPROVE_REQUEST_LIST_LOADING, APPROVE_REQUEST_LIST_SUCCESS, DELETE_LIST_OF_ORGANISATION_FAILED, DELETE_LIST_OF_ORGANISATION_LOADING, DELETE_LIST_OF_ORGANISATION_SUCCESS, DELETE_LIST_OF_USER_UNDER_COMPANY_FAILED, DELETE_LIST_OF_USER_UNDER_COMPANY_LOADING, DELETE_LIST_OF_USER_UNDER_COMPANY_SUCCESS, DELETE_REQUEST_LIST_FAILED, DELETE_REQUEST_LIST_LOADING, DELETE_REQUEST_LIST_SUCCESS, GET_ARCHIVE_LIST_FAILED, GET_ARCHIVE_LIST_LOADING, GET_ARCHIVE_LIST_SUCCESS, GET_LIST_OF_USER_UNDER_COMPANY_FAILED, GET_LIST_OF_USER_UNDER_COMPANY_LOADING, GET_LIST_OF_USER_UNDER_COMPANY_SUCCESS, GET_ORGANISATION_DETAILS_FAILED, GET_ORGANISATION_DETAILS_LOADING, GET_ORGANISATION_DETAILS_SUCCESS, GET_ORGANISATION_EMPLOYEES_FAILED, GET_ORGANISATION_EMPLOYEES_LOADING, GET_ORGANISATION_EMPLOYEES_SUCCESS, GET_ORGANISATION_FAILED, GET_ORGANISATION_LOADING, GET_ORGANISATION_SUCCESS, GET_REQUEST_LIST_FAILED, GET_REQUEST_LIST_LOADING, GET_REQUEST_LIST_SUCCESS, RESTORE_PROJECT_FAILED, RESTORE_PROJECT_LOADING, RESTORE_PROJECT_SUCCESS, UPDATE_LIST_OF_USER_UNDER_COMPANY_FAILED, UPDATE_LIST_OF_USER_UNDER_COMPANY_LOADING, UPDATE_LIST_OF_USER_UNDER_COMPANY_SUCCESS } from "../Constants/adminScreenConstants";




export const getRequestListReducer = (state = {}, action) => {
    switch (action.type) {
        case GET_REQUEST_LIST_LOADING:
            return { getReqLoading: true }
        case GET_REQUEST_LIST_SUCCESS:
            return { getReqLoading: false, getListData: action.payload }
        case GET_REQUEST_LIST_FAILED:
            return { getReqLoading: false, getListError: action.payload }
        default:
            return state;
    }
}


export const getOrganisationDetailsReducer = (state = {}, action) => {
    switch (action.type) {
        case GET_ORGANISATION_DETAILS_LOADING:
            return { getOrganisationDetailsLoading: true }
        case GET_ORGANISATION_DETAILS_SUCCESS:
            return { getOrganisationDetailsLoading: false, getOrganisationDetailsData: action.payload }
        case GET_ORGANISATION_DETAILS_FAILED:
            return { getOrganisationDetailsLoading: false, getListError: action.payload }
        default:
            return state;
    }
}

export const getOrganisationReducer = (state = { getOrganisationData: [] }, action) => {
    switch (action.type) {
        case GET_ORGANISATION_LOADING:
            return { ...state, getOrganisationLoading: true, getOrganisationData: null };

        case GET_ORGANISATION_SUCCESS:
            return { ...state, getOrganisationLoading: false, getOrganisationData: action.payload };

        case GET_ORGANISATION_FAILED:
            return { ...state, getOrganisationLoading: false, getOrganisationData: action.payload };

        default:
            return state;
    }
};

export const getOrganisationEmployeesReducer = (state = { getOrganisationEmployeesData: [] }, action) => {
    switch (action.type) {
        case GET_ORGANISATION_EMPLOYEES_LOADING:
            return { ...state, getOrganisationEmployeesLoading: true, getOrganisationEmployeesData: null };

        case GET_ORGANISATION_EMPLOYEES_SUCCESS:
            return { ...state, getOrganisationEmployeesLoading: false, getOrganisationEmployeesData: action.payload };

        case GET_ORGANISATION_EMPLOYEES_FAILED:
            return { ...state, getOrganisationEmployeesLoading: false, getOrganisationEmployeesData: action.payload };

        default:
            return state;
    }
};

export const getArchiveListReducer = (state = { getArchiveListData: [] }, action) => {
    switch (action.type) {
        case GET_ARCHIVE_LIST_LOADING:
            return { ...state, getArchiveListLoading: true, getArchiveListData: null };

        case GET_ARCHIVE_LIST_SUCCESS:
            return { ...state, getArchiveListLoading: false, getArchiveListData: action.payload };

        case GET_ARCHIVE_LIST_FAILED:
            return { ...state, getArchiveListLoading: false, getArchiveListData: action.payload };

        default:
            return state;
    }
};

export const updateRequestListReducer = (state = {}, action) => {
    switch (action.type) {
        case APPROVE_REQUEST_LIST_LOADING:
            return { updateReqLoading: true }
        case APPROVE_REQUEST_LIST_SUCCESS:
            return { updateReqLoading: false, updatedList: action.payload }
        case APPROVE_REQUEST_LIST_FAILED:
            return { updateReqLoading: false, updateError: action.payload }
        default:
            return state;
    }
}

export const restoreProjectReducer = (state = {}, action) => {
    switch (action.type) {
        case RESTORE_PROJECT_LOADING:
            return { restoreProjectLoading: true }
        case RESTORE_PROJECT_SUCCESS:
            return { restoreProjectLoading: false, restoreProjectData: action.payload }
        case RESTORE_PROJECT_FAILED:
            return { restoreProjectLoading: false, updateError: action.payload }
        default:
            return state;
    }
}

export const deleteRequestListReducer = (state = {}, action) => {
    switch (action.type) {
        case DELETE_REQUEST_LIST_LOADING:
            return { delReqLoading: true }
        case DELETE_REQUEST_LIST_SUCCESS:
            return { delReqLoading: false, deleteSuccess: action.payload }
        case DELETE_REQUEST_LIST_FAILED:
            return { delReqLoading: false, deleteError: action.payload }
        default:
            return state;
    }
}

export const getUsersUnderCompanyReducer = (state = { userListData: [] }, action) => {
    switch (action.type) {
        case GET_LIST_OF_USER_UNDER_COMPANY_LOADING:
            return { userListLoading: true, userListData: [] }
        case GET_LIST_OF_USER_UNDER_COMPANY_SUCCESS:
            return { userListLoading: false, userListData: action.payload }
        case GET_LIST_OF_USER_UNDER_COMPANY_FAILED:
            return { userListLoading: false, userListError: action.payload, userListData: [] }
        default:
            return state;
    }
}

export const updateUsersUnderCompanyReducer = (state = {}, action) => {
    switch (action.type) {
        case UPDATE_LIST_OF_USER_UNDER_COMPANY_LOADING:
            return { updateUserListLoading: true }
        case UPDATE_LIST_OF_USER_UNDER_COMPANY_SUCCESS:
            return { updateUserListLoading: false, updateUserData: action.payload }
        case UPDATE_LIST_OF_USER_UNDER_COMPANY_FAILED:
            return { updateUserListLoading: false, updateUserError: action.payload }
        default:
            return state;
    }
}

export const deleteUsersUnderCompanyReducer = (state = {}, action) => {
    switch (action.type) {
        case DELETE_LIST_OF_USER_UNDER_COMPANY_LOADING:
            return { deleteUserListLoading: true }
        case DELETE_LIST_OF_USER_UNDER_COMPANY_SUCCESS:
            return { deleteUserListLoading: false, deleteUserData: action.payload }
        case DELETE_LIST_OF_USER_UNDER_COMPANY_FAILED:
            return { deleteUserListLoading: false, deleteUserError: action.payload }
        default:
            return state;
    }
}

export const deleteOrganisationReducer = (state = {}, action) => {
    switch (action.type) {
        case DELETE_LIST_OF_ORGANISATION_LOADING:
            return { deleteOrganisationLoading: true }
        case DELETE_LIST_OF_ORGANISATION_SUCCESS:
            return { deleteOrganisationLoading: false, deleteOrganisationData: action.payload }
        case DELETE_LIST_OF_ORGANISATION_FAILED:
            return { deleteOrganisationLoading: false, deleteOrganisationData: action.payload }
        default:
            return state;
    }
}

export const addOrganisationReducer = (state = { loading: false, data: null, error: null }, action) => {
    switch (action.type) {
        case ADD_ORGANISATION_LOADING:
            return { ...state, loading: true, error: null };
        case ADD_ORGANISATION_SUCCESS:
            return { ...state, loading: false, data: action.payload };
        case ADD_ORGANISATION_FAILED:
            return { ...state, loading: false, error: action.payload };
        default:
            return state;
    }
};
